// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"74":"About","88":"potba-configurations","581":"potba-home","764":"potba-parent","784":"Logins"}[chunkId] || chunkId) + "-legacy." + {"74":"8b321337","88":"4794fbbf","107":"49785fe7","581":"54292611","764":"0df935fb","784":"3be41214"}[chunkId] + ".js";
};